import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';

const isHttpSuccess = (status) => status >= 200 && status < 300;

export const fetchUserDevices = (phoneNumber) => async () => {
  const params = new URLSearchParams({
    role_id: '1305',
    phone_number: String(phoneNumber).trim(),
    package_name: 'io.parkplus.valet',
  });

  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.user.userDevices}?${params.toString()}`,
    {
      headers: {
        'package-name': 'io.parkplus.valet',
        platform: 'android',
      },
    }
  );

  if (!res) {
    throw new Error('Failed to fetch user devices');
  }

  if (!isHttpSuccess(res.status)) {
    throw new Error('Failed to fetch user devices');
  }

  if (!Array.isArray(res.data)) {
    throw new Error('Invalid devices response');
  }

  return res.data;
};

export const deactivateUserDevice = (deviceRecordId) => async () => {
  const res = await callWebService(
    callTypes.post,
    {},
    Config.user.deactivateUserDevice(deviceRecordId),
    {
      headers: {
        'package-name': 'io.parkplus.valet',
        platform: 'android',
      },
    }
  );

  if (!res) {
    throw new Error('Failed to deactivate device');
  }

  if (!isHttpSuccess(res.status)) {
    throw new Error('Failed to deactivate device');
  }

  return res.data;
};
